<template>
    <div>
        <div class="pic-wrap">
            <el-row :gutter="20">
                <el-button type="text" icon="el-icon-arrow-left" @click="returnHistory">返回</el-button>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="16">
                    <el-row>
                        <el-col :span="8" offset="1">
                            <span>用户组名称:{{group.groupName}}</span>
                        </el-col>
                        <el-col :span="8">
                            <span>用户组Id:{{group.groupId}}</span>
                        </el-col>
                    </el-row>
                    <el-row>
                        <hr/>
                    </el-row>
                    <!--<el-row>-->
                        <!--<el-form label-width="120px" size="small ">-->
                            <!--<el-form-item v-show="historyList.length>0" label="历史规则">-->
                                <!--<el-alert title="这里仅展示历史规则记录，如果重新保存规则,历史记录被清除" type="success" :closable="false">-->
                                <!--</el-alert>-->
                            <!--</el-form-item>-->
                            <!--<el-form-item v-for="(itemH,indexH) in historyList">-->
                                 <!--<span style="color: red"-->
                                       <!--v-show="itemH.ruleValue.length>0&&itemH.ruleType>0">已筛选{{itemH.tagName}}{{getTypeRuleName(itemH.ruleType, itemH.tagType)}}{{itemH.ruleType == 7 ? itemH.ruleValueName: 'T-' + itemH.ruleValue}}</span>-->
                                <!--<span style="color: red"-->
                                      <!--v-show="itemH.ruleValue.length>0&&itemH.ruleType>0">{{itemH.tagUnit}}用户</span>-->
                            <!--</el-form-item>-->
                        <!--</el-form>-->
                    <!--</el-row>-->
                    <el-row v-for="(item,index) in ruleOptionList" :key="index">
                        <el-form :inline="true" class="demo-form-inline select-wrap"
                                 :size="GCONFIG.styleElFormSize">
                            <el-form-item>
                                <span>{{item.rule.tagName}}</span>
                            </el-form-item>
                            <el-form-item>
                                <el-select v-model="item.rule.ruleType" filterable clear placeholder="请选择">
                                    <el-option v-for="item in getRuleListByType(item.rule.tagType)"
                                               :key="item.id"
                                               :label="item.name"
                                               :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item>
                                <el-date-picker v-if="item.rule.tagType==2"
                                        v-model="item.rule.ruleValue"
                                        type="datetime"
                                                format="yyyy-MM-dd HH:mm:ss"
                                        placeholder="选择日期时间"
                                                align="right"
                                        :picker-options="pickerOptions">
                                </el-date-picker>
                                <el-input v-if="item.rule.tagType==1" v-model="item.rule.ruleValue"  placeholder=""
                                          clearable></el-input>
                                <el-input-number v-if="item.rule.tagType==3" v-model="item.rule.ruleValue"  :min="1" :max="1000" label="描述文字"></el-input-number>
                                <el-input-number v-if="item.rule.tagType==4" v-model="item.rule.ruleValue"  :precision="2" :step="0.1" :max="1000"></el-input-number>
                                <el-select v-if="item.rule.tagType==5" v-model="item.rule.ruleValue" filterable clear  placeholder="请选择">
                                    <el-option v-for="tagOption in item.optionList"
                                               :key="tagOption.tagKey"
                                               :label="tagOption.tagValue"
                                               :value="tagOption.tagKey">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item>
                                <span>{{item.rule.tagUnit}}</span>
                                <!--<span>{{item.rule.tagType==5?getTagOption(item.rule.ruleValue,item.rule.tagId):item.rule.ruleValue}}</span>-->
                            </el-form-item>
                            <el-form-item>
                                <span>{{item.rule.remark}}</span>
                                <span style="color: red"
                                      v-show="item.rule.ruleType>0">筛选{{item.rule.tagName}}{{getTypeRuleName(item.rule.ruleType, item.rule.tagType)}}{{item.rule.ruleType == 7 ?item.selectName:item.rule.ruleValue}}</span>
                                <span style="color: red"
                                      v-show="item.rule.ruleType>0">{{item.rule.tagUnit}}用户</span>
                            </el-form-item>
                            <el-form-item>
                                <b @click="deleteRuel(index)"><i class="el-icon-error"></i></b>
                            </el-form-item>
                        </el-form>
                    </el-row>
                    <el-row>
                        <el-col :span="4" :offset="2">
                            <el-button type="primary" v-show="ruleOptionList.length>0" size="mini" @click="save()">筛选保存
                            </el-button>
                        </el-col>
                    </el-row>
                </el-col>
                <el-col :span="8">
                    <el-row>
                        <el-col :span="10">
                            单击用户标签筛选用户
                        </el-col>
                    </el-row>
                    <el-row>
                        <hr/>
                    </el-row>
                    <el-row v-for="(item,index) in tagClassList" :key="index">
                        <el-form label-width="100px">
                            <el-form-item>
                                {{item.tagClassName}}
                            </el-form-item>
                            <el-form-item>
                                <hr/>
                            </el-form-item>
                        </el-form>
                        <el-form label-width="100px">
                            <el-form-item v-for="(itemTag,indexx) in item.tagVos" :key="indexx">
                                <el-button type="primary" v-if="itemTag.status==1" size="mini"
                                           @click="add(itemTag,indexx)">{{itemTag.name}}
                                </el-button>
                            </el-form-item>
                        </el-form>
                    </el-row>
                </el-col>
            </el-row>
        </div>
    </div>
</template>
<script>
    //导入 HTTP请求方法
    import {
        saveGroupRuleListApi,
        getTagTypeRuleListApi,
        getRuleListApi,
        getTagListApi,
        getTagListVoListApi,
        getCashticketBatchList,
        getEnableCashticketListApi,
        getMyTagRuleListApi,
        getTagOptionApi,
        getTagOptionListByTagIdApi
    } from '../../api/api';
    import {getRouterPageHash} from '@/api/http';
    import ElRow from "element-ui/packages/row/src/row";
    export default {
        components: {ElRow}, data() {
            return {
                showDialog: false,
                list: [],
                recordsTotal: 0,
                ruleList: [],
                ruleOptionList:[],//ruel 和ruleOption 组合集合
                historyList:[],//历史已选择
                tagClassList: [],//带分类的tag列表
                typeRuleList: [],
                formInline: {
                    tagId: 0,
                    name: '',
                    type:0,
                    platformId: 1,
                    currentPage: 1,
                    pageSize: 50,
                    recordsTotal: 0
                },
                cashList: [],
                tagRuleOption: [],
                selectList:[],
                group: {groupId: this.$route.query.groupId, groupName: this.$route.query.groupName, num: 0},
                loading: true,
                pickerOptions: {
                    shortcuts: [{
                        text: '今天',
                        onClick(picker) {
                            picker.$emit('pick', new Date());
                        }
                    }, {
                        text: '昨天',
                        onClick(picker) {
                            const date = new Date();
                            date.setTime(date.getTime() - 3600 * 1000 * 24);
                            picker.$emit('pick', date);
                        }
                    }, {
                        text: '前天',
                        onClick(picker) {
                            const date = new Date();
                            date.setTime(date.getTime() - 2*3600 * 1000 * 24);
                            picker.$emit('pick', date);
                        }
                    }, {
                        text: '一周前',
                        onClick(picker) {
                            const date = new Date();
                            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', date);
                        }
                    }]
                }
            }
        },
        created() {

        },
        //挂载时候执行
        mounted(){
            this.getList(0);
            //this.getRuleList();
        },
        methods: {
            getList(pid){
                //查询标签
                getTagListVoListApi({pid: pid,groupId:this.$route.query.groupId}).then((res) => {
                    if (res.data.success) {
                        this.tagClassList = res.data.value.list;
                        this.typeRuleList =res.data.value.ruleList;
                        this.selectList=res.data.value.selectList
                        console.log(this.tagClassList);
                        console.log(this.typeRuleList);
                        console.log(this.selectList);
                        this.addHistory(this.typeRuleList);
//                        if(res.data.value.selectList.length>0){
//                            res.data.value.selectList.forEach(function(value){
//                                if(value){
//                                    this.addHistory(value,this.typeRuleList);
//                                }
//                            })
//                        }
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            add(item, index){
                //规则初始化
                let rule = {
                    tagId: item.id,
                    tagName: item.name,
                    tagUnit: item.unit,
                    groupId: this.group.groupId,
                    ruleType: 0,
                    tagType: item.type,
                    status: 1,
                    remark: item.remark
                };
                if(item.type==5||item.type==1){
                    rule.ruleValue=''
                }
                if(item.type==2){
                    rule.ruleValue=new Date()
                }
                if(item.type==3||item.type==4){
                    rule.ruleValue=0
                }
                let ruleOption={rule:rule,optionList:item.tagOptionList,selectName:''};
                console.log(ruleOption);
                this.ruleOptionList.push(ruleOption);
                if (item.type === 5) {
                    this.formInline.tagId = item.id;
                    this.formInline.type = item.type;
                }
            },
            addHistory(typeRuleList){
                this.selectList.forEach(item => {
                    if(item){
                        //规则初始化
                        let rule = {
                            tagId: item.tagId,
                            tagName: item.tagName,
                            tagUnit: item.tagUnit,
                            groupId: item.groupId,
                            ruleType: item.ruleType,
                            tagType: item.tagType,
                            status: 1,
                            remark: item.remark,
                            ruleValue:item.ruleValue
                        };
                        let ruleOption={rule:rule,optionList:typeRuleList,selectName:''};
                        console.log(ruleOption);
                        this.ruleOptionList.push(ruleOption);
                        if (item.type === 5) {
                            this.formInline.tagId = item.id;
                            this.formInline.type = item.type;
                        }
                    }
                })
            },
            edit(row){
            },
            getTagOption(key,tagId){
                if(key&&tagId){
                    console.log('key='+key+',tagId='+tagId)
                    if(key>0){
                        this.ruleOptionList.map(function(value,index,array){
                            if(value.optionList){
                                value.optionList.map(function(tagOption,indexx,arrayy){
                                    console.log(tagOption);
                                    if(tagOption.tagKey == key){
                                        value.selectName=tagOption.tagValue;
                                    }
                                })
                            }
                        })
                    }
                }
            },
            getTagRuleOptionList(query){
                this.loading = true;
                if (query) {
                    this.formInline.name = query;
                }
                getTagOptionListByTagIdApi(this.formInline).then((res) => {
                    this.loading = false;
                    if (res.data.status == 200) {
                        this.ruleOptionList.forEach(item=>{
                            if(item.rule.tagId==this.formInline.tagId){
                                item.tagOptionList=res.data.value.list;
                            }
                        })
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            },
            deleteRuel(index){
                this.ruleOptionList.splice(index, 1)
            },
            save(){
                this.ruleOptionList.forEach(item=>{
                    this.ruleList.push(item.rule);
                })
                //保存应用
                if (this.ruleList.length > 0) {
                    //保存历史选择
                    for (let j = 0; j < this.ruleList.length; j++) {
                        console.log(this.ruleList[j]);
                        if (parseInt(this.ruleList[j].ruleType) == 0) {
                            this.$message({
                                showClose: true,
                                message: '请选择' + this.ruleList[j].tagName + '过滤条件!',
                                type: 'error'
                            });
                            return;
                        }
//                        if (isNaN(this.ruleList[j].ruleValue)) {
//                            this.$message({
//                                showClose: true,
//                                message: this.ruleList[j].tagName + '值必须为数字!',
//                                type: 'error'
//                            });
//                            return;
//                        }
                        if (this.ruleList[j].ruleValue == '') {
                            this.$message({
                                showClose: true,
                                message: this.ruleList[j].tagName + '值必填!',
                                type: 'error'
                            });
                            return;
                        }
                    }
                }else {
                    this.$message({
                        showClose: true,
                        message:  '请选择规则!',
                        type: 'error'
                    });
                    return;
                }
                this.loading = true;
                saveGroupRuleListApi({"list": encodeURIComponent(JSON.stringify(this.ruleList))}).then((res) => {
                    this.loading = false;
                    console.log(res);
                    if (res.data.success) {
                        this.$message({
                            showClose: true,
                            message: res.data.value,
                            type: 'success'
                        });
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                    this.showDialog = false;
                });
            },
            getRuleListByType(tagType){
                return this.typeRuleList.filter(item => item.tagType == tagType);
            },
            getTypeRuleName(typeRule, tagType){
                let arr = this.getRuleListByType(tagType);
                let name = '';
                for (let j = 0; j < arr.length; j++) {
                    if (arr[j].id === typeRule) {
                        name = arr[j].name;
                        break;
                    }
                }
                return name;
            },
            formatDate(datetime) {
                if (datetime == null) {
                    return '';
                } else {
                    var date = new Date(datetime);
                    var year = date.getFullYear(),
                        month = ("0" + (date.getMonth() + 1)).slice(-2),
                        sdate = ("0" + date.getDate()).slice(-2),
                        hour = ("0" + date.getHours()).slice(-2),
                        minute = ("0" + date.getMinutes()).slice(-2),
                        second = ("0" + date.getSeconds()).slice(-2);
                    // 拼接
                    var result = year + "-" + month + "-" + sdate + " " + hour + ":" + minute + ":" + second;
                    // 返回
                    return result;
                }
            },
            returnHistory(){
                window.history.back()
            }
        }
    }
</script>
<style>
    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }

    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }
</style>


// WEBPACK FOOTER //
// src/views/sms/groupRule.vue